const name = 'queryParams'

export {
    name,
}
